import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Link as RouterLink } from "react-router-dom";
import { Box, Link, MobileStepper } from "@material-ui/core";
import { AppStepperButton } from "./InputComponents";
import MobileLoading from "../../../components/MobileLoading";
import { repliValidator } from "../../../components";
import LetsGetKnow from "./LetsGetKnow.component";
import FPQNumbers from "./FPQNumbers.component";
import MyQuotient from "./MyQuotient.component";
import GettingDeeper from "./GettingDeeper.component";
import Pregnancies from "./Pregnancies.component";
import Adoptions from "./Adoptions.component";
import Stepchildren from "./Stepchildren.component";
import ChildrenLoss from "./ChildrenLoss.component";
import Contraception from "./Contraception.component";
import FertilityPreservation from "./FertilityPreservation.component";
import FertilityTreatment from "./FertilityTreatment.component";
import SaveResult from "./SaveResult.component";
import CancerDiagnosis from "./CancerDiagnosis.component";

import useStyles from "./Profiler.style";
import Cookies from "universal-cookie";
//import ThermostatSatification from './ThermostatSatification.component';
import Menopause from "./Menopause.component";
import GeneticTesting from "./GeneticTesting.component";
import { arrayOfNumbers } from "../../../services/util.service";

const cookies = new Cookies();

const Profiler = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  const classes = useStyles();

  const currentYear = new Date().getFullYear();

  const letsGetKnowValidator = useRef(
    repliValidator({
      validators: {
        race_self_describe: {
          message: "Please self describe your race",
          rule: (val, params, validator) => {
            if (params.includes("Prefer to self-describe")) return val !== "";
            return true;
          },
          required: true,
        },
        gender_identity_self_describe: {
          message: "Please self describe your gender identity",
          rule: (val, params, validator) => {
            if (params[0] === "Prefer to self-describe") return val !== "";
            return true;
          },
          required: true,
        },
        sexual_preference_self_describe: {
          message: "Please self describe your sexual preference",
          rule: (val, params, validator) => {
            if (params.includes("Prefer to self-describe")) return val !== "";
            return true;
          },
          required: true,
        },
      },
    })
  );

  const gettingDeeperValidator = useRef(
    repliValidator({
      validators: {
        current_pregnancy_due_date_year: {
          message: "Please inform pregnancy due date year",
          rule: (val, params, validator) => {
            if (params[0] === "Currently Pregnant") return val !== "";
            return true;
          },
          required: true,
        },
      },
    })
  );

  const menopauseValidator = useRef(
    repliValidator({
      validators: {
        menopause: {
          message: "This field is required",
          rule: (val, params, validator) => {
            if (["Yes"].includes(params[0])) return val !== "";
            return true;
          },
          required: true,
        },
        menopause_unsure: {
          message: "This field is required",
          rule: (val, params, validator) => {
            if (["Unsure"].includes(params[0])) return val.length >= 3;
            return true;
          },
          required: true,
        },
        menopause_unsure_age: {
          message: "This field is required",
          rule: (val, params, validator) => {
            if (["Unsure"].includes(params[0])) return val !== "";
            return true;
          },
          required: true,
        },
      },
    })
  );
  const fpqnumbersValidator = useRef(
    repliValidator({
      validators: {
        thoughtAboutDesChildren: {
          message: "This field is required",
          rule: (val, params, validator) => val !== "",
          required: true,
        },
      },
    })
  );


  const pregnanciesValidator = useRef(repliValidator());
  const adoptionsValidator = useRef(repliValidator());
  const stepchildrenValidator = useRef(repliValidator());
  const childrenLossValidator = useRef(repliValidator());
  const contraceptionValidator = useRef(
    repliValidator({
      validators: {
        period_year: {
          message: "Please inform year",
          rule: (val, params, validator) => {
            if (!["None"].includes(params[0])) {
              return val !== "";
            }

            return true;
          },

          required: true,
        },
      },
    })
  );

  const fertilityPreservationValidator = useRef(
    repliValidator({
      validators: {
        fertility_preservation_other_method: {
          message: "Please enter method description",
          rule: (val, params, validator) => {
            if (params[0] === "Other") return val !== "";
            return true;
          },
          required: true,
        },
        period_year: {
          message: "Please inform year",
          rule: (val, params, validator) => {
            if (!["", "None"].includes(params[0])) return val !== "";
            return true;
          },
          required: true,
        },
      },
    })
  );

  const fertilityTreatmentValidator = useRef(
    repliValidator({
      validators: {
        period_year: {
          message: "Please inform year",
          rule: (val, params, validator) => {
            if (!["", "None"].includes(params[0])) return val !== "";
            return true;
          },
          required: true,
        },
      },
    })
  );

  const cancerDiagnosisAndTreatmentsValidator = useRef(
    repliValidator({
      validators: {
        describe_pending_cancer_diagnosis: {
          message: "Please select pending cancer diagnosis",
          rule: (val, params, validator) => {
            if (params[0] === "Yes") return val !== "";
            return true;
          },
          required: true,
        },
        describe_other_pending_cancer_diagnosis: {
          message: "Please describe other pending cancer diagnosis",
          rule: (val, params, validator) => {
            if (params[0] === "Other") return val !== "";
            return true;
          },
          required: true,
        },
        describe_current_site_of_cancer: {
          message: "Please describe your current site of cancer",
          rule: (val, params, validator) => {
            if (params[0] === "Currently") return val !== "";
            return true;
          },
          required: true,
        },
        other_site_of_cancer: {
          message: "Please describe other site of cancer",
          rule: (val, params, validator) => {
            if (params[0] === "Other") return val !== "";
            return true;
          },
          required: true,
        },
        other_treatment_type: {
          message: "Please describe other treatment type",
          rule: (val, params, validator) => {
            if (params[0] === "Other") return val !== "";
            return true;
          },
          required: true,
        },

        treatment_year: {
          message: "Please select the year",
          rule: (val, params, validator) => {
            if (!["None"].includes(params[0])) {
              console.log(["none"]);
              return val !== "";
            }

            return true;
          },
          required: true,
        },
      },
    })
  );

  const geneticTestingValidator = useRef(
    repliValidator({
      validators: {
        other_testType: {
          message: "This field is required",
          rule: (val, params, validator) => {
            if (
              (params[0] === "Other" || params[0] === "Carrier screening") &&
              params[1] === "Yes"
            )
              return val !== "";
            return true;
          },
          required: true,
        },
        cancer_geneType: {
          message: "This field is required",
          rule: (val, params, validator) => {
            if (params[0] === "Cancer genetic testing" && params[1] === "Yes")
              return val !== "";
            return true;
          },
          required: true,
        },
        test_field_req: {
          message: "This field is required",
          rule: (val, params, validator) => {
            if (params[0] === "Yes") return val !== "";
            return true;
          },
          required: true,
        },
      },
    })
  );

  const [validationError, setValidationError] = useState(false);

  const [loading, setLoading] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [navigationDirection, setNavigationDirection] = useState("");

  const [dateOfBirth, setDateOfBirth] = useState("");
  const [selectedRaces, setSelectedRaces] = useState([]);
  const [raceSelfDescribe, setRaceSelfDescribe] = useState("");
  const [gender, setGender] = useState("");
  const [genderIdentity, setGenderIdentity] = useState("");
  const [genderIdentitySelfDescribe, setGenderIdentitySelfDescribe] =
    useState("");
  const [selectedSexualPreferences, setSelectedSexualPreferences] = useState(
    []
  );
  const [sexualPreferenceSelfDescribe, setSexualPreferenceSelfDescribe] =
    useState("");
  const [relationshipStatus, setRelationshipStatus] = useState("");
  const [childrenPlan, setChildrenPlan] = useState("");
  const [plannedChildBearingYears, setPlannedChildBearingYears] = useState("");
  const [thoughtAboutDesChildren, setThoughtAboutDesChildren] = useState("");
  const [currentPregnancyDueDate, setCurrentPregnancyDueDate] = useState("");
  const [childbearingYears, setChildbearingYears] = useState([18, 45]);
  const [currentChildrenQty, setCurrentChildrenQty] = useState(0);
  const [desiredChildrenQty, setDesiredChildrenQty] = useState(0);
  const [firstPeriodAge, setFirstPeriodAge] = useState("");
  const [sexuallyActiveAge, setSexuallyActiveAge] = useState("");
  const [menopause, setMenopause] = useState("");
  const [menopauseAge, setMenopauseAge] = useState("");
  const [haveBeenPregnant, setHaveBeenPregnant] = useState("");
  const [pregnancies, setPregnancies] = useState([]);
  const [adoptions, setAdoptions] = useState([]);
  const [stepchildren, setStepchildren] = useState([]);
  const [childrenLoss, setChildrenLoss] = useState([]);
  const [contraception, setContraception] = useState([]);
  const [fertilityPreservation, setFertilityPreservation] = useState([]);
  const [fertilityTreatment, setFertilityTreatment] = useState([]);
  const [anyCancerDiagnosis, setCancerDiagnosis] = useState("");
  const [pendingCancerDiagnosis, setPendingCancerDiagnosis] = useState("");
  const [otherPendingCancerDiagnosis, setOtherPendingCancerDiagnosis] =
    useState("");
  const [currentSiteOfCancer, setCurrentSiteOfCancer] = useState("");
  const [cancerDiagnosisAndTreatments, setCancerDiagnosisAndTreatments] =
    useState([]);

  //Menopause Module
  const [menopauseStatus, setMenopauseStatus] = useState("");
  const [menopauseReason, setMenopauseReason] = useState("");
  const [menopauseSymptonAge, setMenopauseSymptonAge] = useState("");
  const [selectedMenopauseSymptons, setSelectedMenopauseSymptons] = useState(
    []
  );

  //Genetic Testing module

  const [anyGeneticTesting, setAnyGeneticTesting] = useState("");
  const [geneticTesting, setGeneticTesting] = useState([]);

  const totalSteps = 15;

  //Load profile
  useEffect(() => {
    const getHealthProfile = async () => {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_PROFILE}`,
          {
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },
          }
        );
        if (!response) return;
        let profile = await response.json();
        if (profile.dateOfBirth)
          setDateOfBirth(
            moment(profile.dateOfBirth).utc().format("YYYY-MM-DD")
          );
        if (profile.races) setSelectedRaces(profile.races);
        if (profile.raceSelfDescribe)
          setRaceSelfDescribe(profile.raceSelfDescribe);
        if (profile.gender) setGender(profile.gender);
        if (profile.genderIdentity) setGenderIdentity(profile.genderIdentity);
        if (profile.genderIdentitySelfDescribe)
          setGenderIdentitySelfDescribe(profile.genderIdentitySelfDescribe);
        if (profile.sexualPreferences)
          setSelectedSexualPreferences(profile.sexualPreferences);
        if (profile.sexualPreferenceSelfDescribe)
          setSexualPreferenceSelfDescribe(profile.sexualPreferenceSelfDescribe);
        if (profile.relationshipStatus)
          setRelationshipStatus(profile.relationshipStatus);
        if (profile.childrenPlan) setChildrenPlan(profile.childrenPlan);
        if (profile.plannedChildBearingYears)
          setPlannedChildBearingYears(profile.plannedChildBearingYears);
        if (profile.thoughtAboutDesChildren)
          setThoughtAboutDesChildren(profile.thoughtAboutDesChildren);
        setChildbearingYears(profile.childbearingYearFrame);
        setCurrentChildrenQty(profile.currentChildrenQty || 0);
        setDesiredChildrenQty(profile.desiredChildrenQty || 0);
        if (profile.firstPeriodAge) setFirstPeriodAge(profile.firstPeriodAge);
        if (profile.sexuallyActiveAge)
          setSexuallyActiveAge(profile.sexuallyActiveAge);
        if (profile.menopause) setMenopause(profile.menopause);
        if (profile.menopauseAge) setMenopauseAge(profile.menopauseAge);
        if (profile.menopauseStatus)
          setMenopauseStatus(profile.menopauseStatus);
        if (profile.menopauseReason)
          setMenopauseReason(profile.menopauseReason);
        if (profile.menopauseSymptonAge)
          setMenopauseSymptonAge(profile.menopauseSymptonAge);
        if (profile.selectedMenopauseSymptons)
          setSelectedMenopauseSymptons(profile.selectedMenopauseSymptons);
        if (profile.haveBeenPregnant)
          setHaveBeenPregnant(profile.haveBeenPregnant);
        if (profile.currentPregnancyDueDate)
          setCurrentPregnancyDueDate(profile.currentPregnancyDueDate);
        if (profile.pregnancies) setPregnancies(profile.pregnancies);
        if (profile.adoptions) setAdoptions(profile.adoptions);
        if (profile.stepchildren) setStepchildren(profile.stepchildren);
        if (profile.childrenLoss) setChildrenLoss(profile.childrenLoss);
        if (profile.contraception) setContraception(profile.contraception);
        if (profile.fertilityPreservation)
          setFertilityPreservation(profile.fertilityPreservation);
        if (profile.fertilityTreatment)
          setFertilityTreatment(profile.fertilityTreatment);
        if (profile.cancers) {
          profile.cancers.forEach((cancer) => {
            cancer.treatments.forEach((treatment) => {
              treatment.fromYears = [
                ...arrayOfNumbers(cancer.year, currentYear - cancer.year + 1),
              ];
              treatment.toYears = [
                ...arrayOfNumbers(cancer.year, currentYear - cancer.year + 1),
              ];
            });
          });
          setCancerDiagnosisAndTreatments(profile.cancers);
        }
        if (profile.anyCancerDiagnosis)
          setCancerDiagnosis(profile.anyCancerDiagnosis);
        if (profile.pendingCancerDiagnosis)
          setPendingCancerDiagnosis(profile.pendingCancerDiagnosis);
        if (profile.otherPendingCancerDiagnosis)
          setOtherPendingCancerDiagnosis(profile.otherPendingCancerDiagnosis);
        if (profile.currentSiteOfCancer)
          setCurrentSiteOfCancer(profile.currentSiteOfCancer);
        if (profile.anyGeneticTesting)
          setAnyGeneticTesting(profile.anyGeneticTesting);
        if (profile.geneticTesting) setGeneticTesting(profile.geneticTesting);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    getHealthProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Clean up pregnancies if previus questions has a No answer
  useEffect(() => {
    if (haveBeenPregnant === "No") setPregnancies([]);
  }, [haveBeenPregnant]);

  //Force ate least 1 contraception, even if it's none
  useEffect(() => {
    if (!contraception?.length)
      setContraception([{ yearFrom: "", yearTo: "", method: "" }]);
  }, [contraception]);

  //Force ate least 1 fertility preservation method, even if it's none
  useEffect(() => {
    if (!fertilityPreservation?.length)
      setFertilityPreservation([
        { yearFrom: "", yearTo: "", method: "", otherMethod: "" },
      ]);
  }, [fertilityPreservation]);

  //Force ate least 1 fertility treatment even if it's none
  useEffect(() => {
    if (!fertilityTreatment?.length)
      setFertilityTreatment([{ yearFrom: "", yearTo: "", treatment: "" }]);
  }, [fertilityTreatment]);

  const isRaceChecked = (race) => {
    return selectedRaces.includes(race);
  };

  const isSexualPreferenceChecked = (preference) => {
    return selectedSexualPreferences.includes(preference);
  };

  const handleSelectedRacesCheck = (race) => {
    if (!isRaceChecked(race)) setSelectedRaces([...selectedRaces, race]);
    else setSelectedRaces(selectedRaces.filter((item) => item !== race));
  };

  const handleSexualPreferenceCheck = (preference) => {
    if (!isSexualPreferenceChecked(preference))
      setSelectedSexualPreferences([...selectedSexualPreferences, preference]);
    else
      setSelectedSexualPreferences(
        selectedSexualPreferences.filter((item) => item !== preference)
      );
  };

  const handleChildrenPlanChange = (e, newValue) => {
    setChildrenPlan(newValue);
    if (newValue === "No") {
      setChildbearingYears([]);
      setPlannedChildBearingYears("");
    }
  };

  const handlePlannedChildBearingYears = (e, newValue) => {
    setPlannedChildBearingYears(newValue);
    if (newValue === "No") setChildbearingYears([]);
    else if (childbearingYears === undefined || !childbearingYears?.length)
      setChildbearingYears([18, 45]);
  };

  const handleThoughtAboutDesChildren = (e, newValue) => {
    setThoughtAboutDesChildren(newValue);
    if (newValue === "No" || newValue === "Undecided") {
      setDesiredChildrenQty("");
    }
  };

  const handleMenopauseChange = (e) => {
    setMenopause(e.target.value);
    if (e.target.value === "No") {
      setMenopauseAge("");
      setMenopauseReason("");
      setMenopauseStatus("");
      setSelectedMenopauseSymptons([]);
      setMenopauseSymptonAge("");
    } else if (e.target.value === "Unsure") {
      setMenopauseAge("");
      setMenopauseReason("");
      setMenopauseStatus("");
    } else {
      setSelectedMenopauseSymptons([]);
      setMenopauseSymptonAge("");
    }
  };

  // const handleThermostatChange = e => {
  // 	if (e.target.value !== "Other") {
  // 		setOtherThermostat('');
  // 	}
  // 	setThermostat(e.target.value);
  // }

  // const handleOtherThermostatChange = e => {
  // 	const validSelfDescribe = new RegExp(/[a-zA-Z0-9][\\sa-zA-Z0-9]{0,40}/);

  // 	if (validSelfDescribe.test(e.target.value) || e.target.value === '') {
  // 		setOtherThermostat(e.target.value);
  // 	}
  // }

  const handleSelfDescribeChange = (e, selfDescribeType) => {
    const validSelfDescribe = new RegExp(/[a-zA-Z0-9][\\sa-zA-Z0-9]{0,40}/);

    if (validSelfDescribe.test(e.target.value) || e.target.value === "") {
      if (selfDescribeType === "Race Self Describe") {
        setRaceSelfDescribe(e.target.value);
      } else if (selfDescribeType === "Gender Identity Self Describe") {
        setGenderIdentitySelfDescribe(e.target.value);
      } else if (selfDescribeType === "Sexual Preference Self Describe") {
        setSexualPreferenceSelfDescribe(e.target.value);
      }
    }
  };

  const handleCancerDiagnosisChange = (e) => {
    setCancerDiagnosis(e.target.value);
    if (e.target.value === "No" || e.target.value === "Currently") {
      setCancerDiagnosisAndTreatments([]);
      setCurrentSiteOfCancer("");
    } else {
      setCancerDiagnosisAndTreatments([
        {
          siteOfCancer: "",
          otherSiteOfCancer: "",
          year: "",
          treatments: [
            {
              treatmentType: "",
              otherTreatmentType: "",
              treatmentFromYear: "",
              treatmentToYear: "",
              fromYears: [],
              toYears: [],
            },
          ],
        },
      ]);
    }
  };

  const handleAddItemStateArray = (
    event,
    cancerIndex,
    currentArray,
    newDefaultTreatment
  ) => {
    let modifiedData = cancerDiagnosisAndTreatments.map((data, i) => {
      if (i === cancerIndex) {
        let newArray = [...currentArray, newDefaultTreatment];
        data.treatments = newArray;
      }
      return data;
    });
    setCancerDiagnosisAndTreatments(modifiedData);
  };

  const handleRemoveItemStateArray = (
    event,
    removeTreatmentIndex,
    cancerIndex
  ) => {
    let modifiedData = cancerDiagnosisAndTreatments.map((data, i) => {
      if (i === cancerIndex) {
        data.treatments.splice(removeTreatmentIndex, 1);
      }
      return data;
    });
    setCancerDiagnosisAndTreatments(modifiedData);
  };

  const handleStateArrayItemChange = (
    event,
    treatmentProperty,
    treatmentIndex,
    cancerIndex
  ) => {
    let modifiedData = cancerDiagnosisAndTreatments.map((data, i) => {
      if (i === cancerIndex) {
        if (
          ["None"].includes(event.target.value) &&
          treatmentProperty === "treatmentType"
        ) {
          data.treatments[treatmentIndex].otherTreatmentType = "";
          data.treatments[treatmentIndex].treatmentFromYear = "";
          data.treatments[treatmentIndex].treatmentToYear = "";
          data.treatments[treatmentIndex].treatmentType = "None";
        } else if (
          data.treatments[treatmentIndex].treatmentType === "Other" &&
          treatmentProperty === "otherTreatmentType"
        ) {
          const validInput = new RegExp(/[a-zA-Z0-9][\\sa-zA-Z0-9]{0,40}/);
          if (
            validInput.test(event.target.value) ||
            event.target.value === ""
          ) {
            data.treatments[treatmentIndex][treatmentProperty] =
              event.target.value;
          }
        } else if (treatmentProperty === "treatmentFromYear") {
          data.treatments[treatmentIndex][treatmentProperty] =
            event.target.value;
          data.treatments[treatmentIndex].toYears = [
            ...arrayOfNumbers(
              event.target.value,
              currentYear - event.target.value + 1
            ),
          ];
          if (
            data.treatments[treatmentIndex].treatmentToYear !== "" &&
            data.treatments[treatmentIndex].treatmentFromYear >
              data.treatments[treatmentIndex].treatmentToYear
          ) {
            data.treatments[treatmentIndex][treatmentProperty] = "";
            data.treatments[treatmentIndex].treatmentToYear = "";
          } else {
            data.treatments[treatmentIndex][treatmentProperty] =
              event.target.value;
            data.treatments[treatmentIndex].toYears = [
              ...arrayOfNumbers(
                event.target.value,
                currentYear - event.target.value + 1
              ),
            ];
          }
        } else if (treatmentProperty === "treatmentToYear") {
          if (
            event.target.value <
            data.treatments[treatmentIndex].treatmentFromYear
          ) {
            data.treatments[treatmentIndex][treatmentProperty] = "";
            data.treatments[treatmentIndex].treatmentFromYear = "";
          } else {
            data.treatments[treatmentIndex][treatmentProperty] =
              event.target.value;
          }
        } else {
          data.treatments[treatmentIndex][treatmentProperty] =
            event.target.value;
          if (
            data.treatments[treatmentIndex].treatmentType === "Other" &&
            treatmentProperty === "otherTreatmentType"
          ) {
            data.treatments[treatmentIndex][treatmentProperty] =
              event.target.value.trimStart();
          }
        }
      }
      return data;
    });
    setCancerDiagnosisAndTreatments(modifiedData);
  };

  const handleAddCancerItemStateArray =
    (currentArray, newItemDefault, setter) => async (e) => {
      let newArray = [...currentArray, newItemDefault];
      setter(newArray);
    };

  const handleAnyGenticTestingChange = (e) => {
    setAnyGeneticTesting(e.target.value);
    if (e.target.value === "No" || e.target.value === "Unsure") {
      setGeneticTesting([]);
    } else {
      setGeneticTesting([
        {
          testType: "",
          anyPositiveGeneticTesting: "",
          otherTestType: "",
          cancerGeneType: "",
          year: "",
          copyOfGeneticTesting: "",
        },
      ]);
    }
  };

  const handleBackClick = () => {
    setNavigationDirection("backward");
    setActiveStep(activeStep - 1);
    scrollToTop();
  };

  const handleNextClick = () => {
    let validators = [
      { step: 0, validator: letsGetKnowValidator },
	  { step: 1, validator: fpqnumbersValidator },
      { step: 3, validator: gettingDeeperValidator },
      { step: 4, validator: menopauseValidator },
      { step: 5, validator: pregnanciesValidator },
      { step: 6, validator: adoptionsValidator },
      { step: 7, validator: stepchildrenValidator },
      { step: 8, validator: childrenLossValidator },
      { step: 9, validator: contraceptionValidator },
      { step: 10, validator: fertilityPreservationValidator },
      { step: 11, validator: fertilityTreatmentValidator },
      { step: 12, validator: cancerDiagnosisAndTreatmentsValidator },
      { step: 13, validator: geneticTestingValidator },
    ];
    let activeValidator = validators.find(
      (validator) => validator.step === activeStep
    );
    if (activeValidator) {
      let error = !activeValidator.validator.current.allValid();
      setValidationError(error);
      if (error) {
        activeValidator.validator.current.showMessages();
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }
      validators.forEach((validator) => {
        validator.validator.current.hideMessages();
      });
    }
    setNavigationDirection("forward");
    setActiveStep(activeStep + 1);
  };

  const handleActiveStepReset = (index) => {
    setActiveStep(index);
  };

  const isMenopauseSymptonChecked = (sympton) => {
    return selectedMenopauseSymptons.includes(sympton);
  };

  const handleMenopauseSymptonChange = (sympton) => {
    if (!isMenopauseSymptonChecked(sympton))
      setSelectedMenopauseSymptons([...selectedMenopauseSymptons, sympton]);
    else
      setSelectedMenopauseSymptons(
        selectedMenopauseSymptons.filter((item) => item !== sympton)
      );
  };

  const handlePositiveGeneticTestingChange = (index, value) => {
    let modifiedData = geneticTesting.map((data, i) => {
      if (i === index && (value === "No" || value === "Unsure")) {
        data["anyPositiveGeneticTesting"] = value;
        data["otherTestType"] = "";
        data["cancerGeneType"] = "";
        data["year"] = "";
        data["copyOfGeneticTesting"] = "";
      } else if (i === index && value === "Yes") {
        data["anyPositiveGeneticTesting"] = value;
      }
      return data;
    });
    setGeneticTesting(modifiedData);
  };

  const handleOtherFPChange = (event, method, index) => {
    let modifiedData = fertilityPreservation.map((data, i) => {
      if (i === index) {
        const validInput = new RegExp(/[a-zA-Z0-9][\\sa-zA-Z0-9]{0,40}/);
        if (validInput.test(event.target.value) || event.target.value === "") {
          data[method] = event.target.value;
        }
      }
      return data;
    });
    setFertilityPreservation(modifiedData);
  };

  const positiveCarrierGTChange = (event, method, index) => {
    let modifiedData = geneticTesting.map((data, i) => {
      if (i === index) {
        const validInput = new RegExp(/[a-zA-Z0-9][\\sa-zA-Z0-9]{0,40}/);
        if (validInput.test(event.target.value) || event.target.value === "") {
          data[method] = event.target.value;
        }
      }
      return data;
    });
    setGeneticTesting(modifiedData);
  };

  const handleOtherCancerDiagnosis = (event, cancerProperty, index) => {
    let modifiedData = cancerDiagnosisAndTreatments.map((data, i) => {
      if (i === index) {
        const validInput = new RegExp(/[a-zA-Z0-9][\\sa-zA-Z0-9]{0,40}/);
        if (validInput.test(event.target.value) || event.target.value === "") {
          data[cancerProperty] = event.target.value;
        }
      }
      return data;
    });
    setCancerDiagnosisAndTreatments(modifiedData);
  };

  const handleCancerDiagnosisYearChange = (event, index) => {
    let modifiedData = cancerDiagnosisAndTreatments.map((data, i) => {
      if (i === index) {
        data["year"] = event.target.value;
        if (data["year"]) {
          data["treatments"].forEach((treatment) => {
            treatment.fromYears = [
              ...arrayOfNumbers(data["year"], currentYear - data["year"] + 1),
            ];
            treatment.toYears = [
              ...arrayOfNumbers(data["year"], currentYear - data["year"] + 1),
            ];
          });
        }
      }
      return data;
    });
    setCancerDiagnosisAndTreatments(modifiedData);
  };

  if (loading) return <MobileLoading />;

  return (
    <Box className={classes.root}>
      {activeStep === 0 && (
        <LetsGetKnow
          validator={letsGetKnowValidator.current}
          error={validationError}
          dateOfBirth={dateOfBirth}
          selectedRaces={selectedRaces}
          raceSelfDescribe={raceSelfDescribe}
          gender={gender}
          genderIdentity={genderIdentity}
          genderIdentitySelfDescribe={genderIdentitySelfDescribe}
          selectedSexualPreferences={selectedSexualPreferences}
          sexualPreferenceSelfDescribe={sexualPreferenceSelfDescribe}
          relationshipStatus={relationshipStatus}
          childrenPlan={childrenPlan}
          plannedChildBearingYears={plannedChildBearingYears}
          handlePlannedChildBearingYears={handlePlannedChildBearingYears}
          childbearingYears={childbearingYears}
          onDateBirthChange={(e) => setDateOfBirth(e.target.value)}
          onSelectedRacesChange={handleSelectedRacesCheck}
          onRaceSelfDescribeChange={(e, race) =>
            handleSelfDescribeChange(e, race)
          }
          onGenderChange={(e, newValue) => setGender(newValue)}
          onGenderIdentityChange={(e, newValue) => setGenderIdentity(newValue)}
          onGenderIdentitySelfDescribeChange={(e, genderIdentity) =>
            handleSelfDescribeChange(e, genderIdentity)
          }
          onSexualPreferenceChange={handleSexualPreferenceCheck}
          onSexualPreferenceSelfDescribeChange={(e, sexualPreference) =>
            handleSelfDescribeChange(e, sexualPreference)
          }
          onRelationshipStatusChange={(e) =>
            setRelationshipStatus(e.target.value)
          }
          onChildrenPlanChange={handleChildrenPlanChange}
          onChildbearingYearsChange={(e, newValue) =>
            setChildbearingYears(newValue)
          }
        />
      )}
      {activeStep === 1 && (
        <FPQNumbers
          validator={fpqnumbersValidator.current}
          currentChildrenQty={currentChildrenQty}
          desiredChildrenQty={desiredChildrenQty}
          thoughtAboutDesChildren={thoughtAboutDesChildren}
          handleThoughtAboutDesChildren={handleThoughtAboutDesChildren}
          onCurrentChildrenQtyChange={(e, newValue) =>
            setCurrentChildrenQty(newValue)
          }
          onDesiredChildrenQtyChange={(e, newValue) =>
            setDesiredChildrenQty(newValue)
          }
        />
      )}
      {activeStep === 2 && (
        <MyQuotient
          currentChildrenQty={currentChildrenQty}
          desiredChildrenQty={desiredChildrenQty}
        />
      )}
      {activeStep === 3 && (
        <GettingDeeper
          validator={gettingDeeperValidator.current}
          error={validationError}
          dateOfBirth={dateOfBirth}
          firstPeriodAge={firstPeriodAge}
          sexuallyActiveAge={sexuallyActiveAge}
          menopause={menopause}
          haveBeenPregnant={haveBeenPregnant}
          currentPregnancyDueDate={currentPregnancyDueDate}
          onFirstPeriodAgeChange={(e) => setFirstPeriodAge(e.target.value)}
          onSexuallyActiveAgeChange={(e) =>
            setSexuallyActiveAge(e.target.value)
          }
          onMenopauseChange={handleMenopauseChange}
          onHaveBeenPregnantChange={(e) => setHaveBeenPregnant(e.target.value)}
          onCurrentPregnancyDueDateChange={(e) =>
            setCurrentPregnancyDueDate(e.target.value)
          }
        />
      )}
      {activeStep === 4 && (
        <Menopause
          validator={menopauseValidator.current}
          error={validationError}
          dateOfBirth={dateOfBirth}
          firstPeriodAge={firstPeriodAge}
          menopause={menopause}
          menopauseAge={menopauseAge}
          menopauseSymptonAge={menopauseSymptonAge}
          menopauseStatus={menopauseStatus}
          menopauseReason={menopauseReason}
          selectedMenopauseSymptons={selectedMenopauseSymptons}
          onMenopauseAgeChange={(e) => setMenopauseAge(e.target.value)}
          onMenopauseStatusChange={(e) => setMenopauseStatus(e.target.value)}
          onMenopauseReasonChange={(e) => setMenopauseReason(e.target.value)}
          onMenopauseSymptonAgeChange={(e) =>
            setMenopauseSymptonAge(String(e.target.value))
          }
          onMenopauseSymptonChanges={handleMenopauseSymptonChange}
          next={handleNextClick}
          back={handleBackClick}
          direction={navigationDirection}
        />
      )}
      {activeStep === 5 && (
        <Pregnancies
          items={pregnancies}
          setter={setPregnancies}
          validator={pregnanciesValidator.current}
          error={validationError}
          dateOfBirth={dateOfBirth}
          firstPeriodAge={firstPeriodAge}
          haveBeenPregnant={haveBeenPregnant}
          next={handleNextClick}
          back={handleBackClick}
          direction={navigationDirection}
        />
      )}
      {activeStep === 6 && (
        <Adoptions
          items={adoptions}
          setter={setAdoptions}
          validator={adoptionsValidator.current}
          error={validationError}
          dateOfBirth={dateOfBirth}
          firstPeriodAge={firstPeriodAge}
        />
      )}
      {activeStep === 7 && (
        <Stepchildren
          items={stepchildren}
          setter={setStepchildren}
          validator={stepchildrenValidator.current}
          error={validationError}
          dateOfBirth={dateOfBirth}
          firstPeriodAge={firstPeriodAge}
        />
      )}
      {activeStep === 8 && (
        <ChildrenLoss
          items={childrenLoss}
          setter={setChildrenLoss}
          validator={childrenLossValidator.current}
          error={validationError}
          dateOfBirth={dateOfBirth}
          firstPeriodAge={firstPeriodAge}
        />
      )}
      {activeStep === 9 && (
        <Contraception
          items={contraception}
          setter={setContraception}
          validator={contraceptionValidator.current}
          error={validationError}
          dateOfBirth={dateOfBirth}
        />
      )}
      {activeStep === 10 && (
        <FertilityPreservation
          items={fertilityPreservation}
          setter={setFertilityPreservation}
          validator={fertilityPreservationValidator.current}
          otherFertilityPreservationChange={(event, method, index) =>
            handleOtherFPChange(event, method, index)
          }
          error={validationError}
          dateOfBirth={dateOfBirth}
        />
      )}
      {activeStep === 11 && (
        <FertilityTreatment
          items={fertilityTreatment}
          setter={setFertilityTreatment}
          validator={fertilityTreatmentValidator.current}
          error={validationError}
          dateOfBirth={dateOfBirth}
        />
      )}
      {activeStep === 12 && (
        <CancerDiagnosis
          items={cancerDiagnosisAndTreatments}
          setter={setCancerDiagnosisAndTreatments}
          validator={cancerDiagnosisAndTreatmentsValidator.current}
          anyCancerDiagnosis={anyCancerDiagnosis}
          currentSiteOfCancer={currentSiteOfCancer}
          onCurrentSiteOfCancerChange={(e) =>
            setCurrentSiteOfCancer(e.target.value.trimStart())
          }
          onCancerDiagnosisChange={handleCancerDiagnosisChange}
          onOtherCancerDiagnosisChange={(event, cancerProperty, index) =>
            handleOtherCancerDiagnosis(event, cancerProperty, index)
          }
          pendingCancerDiagnosis={pendingCancerDiagnosis}
          otherPendingCancerDiagnosis={otherPendingCancerDiagnosis}
          otherPendingCancerDiagnosisChange={(e) =>
            setOtherPendingCancerDiagnosis(e.target.value)
          }
          onCancerDiagnosisYearChange={(event, cancerIndex) => {
            handleCancerDiagnosisYearChange(event, cancerIndex);
          }}
          onPendingCancerDiagnosisChange={(e) =>
            setPendingCancerDiagnosis(e.target.value)
          }
          onTreatmentDelete={(event, treatmentIndex, cancerIndex) =>
            handleRemoveItemStateArray(event, treatmentIndex, cancerIndex)
          }
          onTreatmentAdd={(
            event,
            cancerIndex,
            currentArray,
            newDefaultTreatment
          ) =>
            handleAddItemStateArray(
              event,
              cancerIndex,
              currentArray,
              newDefaultTreatment
            )
          }
          onTreatmentPropertyChange={(
            event,
            treatmentProperty,
            treatmentIndex,
            cancerIndex
          ) =>
            handleStateArrayItemChange(
              event,
              treatmentProperty,
              treatmentIndex,
              cancerIndex
            )
          }
          onCancerDiagnosisAndTreatmentsAdd={handleAddCancerItemStateArray(
            cancerDiagnosisAndTreatments,
            {
              siteOfCancer: "",
              otherSiteOfCancer: "",
              year: "",
              treatments: [
                {
                  treatmentType: "",
                  otherTreatmentType: "",
                  treatmentFromYear: "",
                  treatmentToYear: "",
                  fromYears: [],
                  toYears: [],
                },
              ],
            },
            setCancerDiagnosisAndTreatments
          )}
          error={validationError}
          dateOfBirth={dateOfBirth}
        />
      )}
      {activeStep === 13 && (
        <GeneticTesting
          validator={geneticTestingValidator.current}
          anyGeneticTesting={anyGeneticTesting}
          positiveCarrierGTChanges={(event, method, index) =>
            positiveCarrierGTChange(event, method, index)
          }
          items={geneticTesting}
          setter={setGeneticTesting}
          onGenticTestingChange={(e) => handleAnyGenticTestingChange(e)}
          onPositiveGeneticTestingChange={(index, value) =>
            handlePositiveGeneticTestingChange(index, value)
          }
          error={validationError}
          dateOfBirth={dateOfBirth}
        />
      )}
      {activeStep === 14 && (
        <SaveResult
          dateOfBirth={dateOfBirth}
          races={selectedRaces}
          raceSelfDescribe={raceSelfDescribe}
          gender={gender}
          genderIdentity={genderIdentity}
          genderIdentitySelfDescribe={genderIdentitySelfDescribe}
          sexualPreferences={selectedSexualPreferences}
          sexualPreferenceSelfDescribe={sexualPreferenceSelfDescribe}
          relationshipStatus={relationshipStatus}
          childrenPlan={childrenPlan}
          plannedChildBearingYears={plannedChildBearingYears}
          thoughtAboutDesChildren={thoughtAboutDesChildren}
          childbearingYears={childbearingYears}
          currentChildrenQty={currentChildrenQty}
          desiredChildrenQty={desiredChildrenQty}
          firstPeriodAge={firstPeriodAge}
          sexuallyActiveAge={sexuallyActiveAge}
          menopause={menopause}
          menopauseAge={menopauseAge}
          menopauseStatus={menopauseStatus}
          menopauseReason={menopauseReason}
          menopauseSymptonAge={menopauseSymptonAge}
          selectedMenopauseSymptons={selectedMenopauseSymptons}
          haveBeenPregnant={haveBeenPregnant}
          currentPregnancyDueDate={currentPregnancyDueDate}
          pregnancies={pregnancies}
          adoptions={adoptions}
          stepchildren={stepchildren}
          childrenLoss={childrenLoss}
          contraception={contraception}
          fertilityPreservation={fertilityPreservation}
          fertilityTreatment={fertilityTreatment}
          anyCancerDiagnosis={anyCancerDiagnosis}
          currentSiteOfCancer={currentSiteOfCancer}
          pendingCancerDiagnosis={pendingCancerDiagnosis}
          otherPendingCancerDiagnosis={otherPendingCancerDiagnosis}
          cancerDiagnosisAndTreatments={cancerDiagnosisAndTreatments}
          anyGeneticTesting={anyGeneticTesting}
          geneticTesting={geneticTesting}
          onReviewProfileClick={handleActiveStepReset}
        />
      )}
      {activeStep !== totalSteps - 1 && (
        <Box className={classes.regularFooter}>
          <MobileStepper
            variant="dots"
            steps={totalSteps}
            position="static"
            activeStep={activeStep}
            style={{ backgroundColor: "rgba(0,0,0,0)" }}
          />
          <Box display="flex" justifyContent="space-between" width="100%">
            {activeStep === 0 && (
              <Box flexGrow={1} pr={1}>
                <Link
                  component={RouterLink}
                  to="/app/dashboard"
                  underline="none"
                >
                  <AppStepperButton
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="large"
                    onClick={handleBackClick}
                  >
                    Exit
                  </AppStepperButton>
                </Link>
              </Box>
            )}
            {activeStep > 0 && (
              <Box flexGrow={1} pr={1}>
                <AppStepperButton
                  variant="contained"
                  color="secondary"
                  fullWidth
                  size="large"
                  onClick={handleBackClick}
                >
                  Previous
                </AppStepperButton>
              </Box>
            )}
            <Box flexGrow={1} pl={1}>
              <AppStepperButton
                variant="contained"
                color="secondary"
                fullWidth
                size="large"
                onClick={handleNextClick}
              >
                Continue
              </AppStepperButton>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Profiler;
